import { Reveal } from "./motion";

export default function Posicionamento() {
  return (
    <section className="bg-brand-deep grain relative overflow-hidden py-24 md:py-32" data-testid="posicionamento-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-accent-soft text-xs font-semibold uppercase tracking-[0.35em]">Minha proposta</p>
          <h2 className="mt-6 max-w-4xl font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.1] text-balance">
            Foz é muito mais do que um destino.{" "}
            <span className="font-serif italic font-medium text-accent-soft">É uma experiência para viver.</span>
          </h2>
          <p className="mt-8 max-w-2xl text-white/75 text-base md:text-lg leading-relaxed">
            Eu ajudo você a conhecer os principais destinos da Tríplice Fronteira com conforto, praticidade e atendimento personalizado.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
